var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'MainGroupbuyingsList'
      }
    }
  }, [_vm._v("總公司團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), [[_vm.GROUPBUYING_STATUS.DRAFT, _vm.GROUPBUYING_STATUS.WAITING, _vm.GROUPBUYING_STATUS.GOING].includes(_vm.status) && _vm.mode === _vm.MODE.READONLY ? _c('b-button', {
    attrs: {
      "variant": "warning",
      "to": {
        name: 'MainGroupbuyingsEdit',
        params: {
          groupbuyID: _vm.groupbuyID
        }
      }
    }
  }, [_vm._v("編輯團購")]) : _vm._e(), [_vm.GROUPBUYING_STATUS.DRAFT, _vm.GROUPBUYING_STATUS.WAITING].includes(_vm.status) && _vm.mode === _vm.MODE.READONLY ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "inverse-danger"
    },
    on: {
      "click": _vm.handleDelete
    }
  }, [_vm._v("刪除團購")]) : _vm._e()], _c('section', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "h5"
  }, [_vm._v("Step 1: 請選擇分店")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "團購分店",
      "label-for": "input-1"
    }
  }, [_vm.mode === _vm.MODE.CREATE ? _c('b-form-radio-group', {
    attrs: {
      "id": "checkbox-group-2",
      "stacked": ""
    },
    model: {
      value: _vm.branchGroup,
      callback: function callback($$v) {
        _vm.branchGroup = $$v;
      },
      expression: "branchGroup"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": _vm.BRANCH_GROUP.ALL
    }
  }, [_c('div', [_vm._v("全部分店")])]), _c('b-form-radio', {
    attrs: {
      "value": _vm.BRANCH_GROUP.ONE
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": "選擇分店",
      "size": "sm",
      "disabled": _vm.branchGroup !== _vm.BRANCH_GROUP.ONE
    },
    model: {
      value: _vm.branch_id,
      callback: function callback($$v) {
        _vm.branch_id = $$v;
      },
      expression: "branch_id"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v("選擇分店")]), _vm._l(_vm.branchOptions, function (branch) {
    return _c('b-form-select-option', {
      key: branch.value,
      attrs: {
        "value": branch.value
      }
    }, [_vm._v(_vm._s(branch.text))]);
  })], 2)], 1), _c('b-form-radio', {
    attrs: {
      "value": _vm.BRANCH_GROUP.EXCEL
    }
  }, [_c('div', {
    staticClass: "form-group d-inline-flex align-items-center"
  }, [_c('div', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("上傳分店")]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.uploadBranches
    }
  })], 1), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "href": "/excel/branch_list.xlsx"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案")])], 1)], 1) : _c('div', [_c('BranchesTable', {
    attrs: {
      "branches": _vm.targetBranches
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "mb-8"
  }, [_c('div', {
    staticClass: "h5"
  }, [_vm._v("Step 2: 請編輯團購設定")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "content-cols": "12",
      "content-cols-lg": "7",
      "label-size": "sm",
      "label": "請輸入商品編號，輸入完畢後，請按確認"
    }
  }, [_c('div', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入商品編號",
      "disabled": _vm.mode === _vm.MODE.EDIT || _vm.mode === _vm.MODE.READONLY,
      "state": _vm.v$.form.product_ids.$error ? false : null
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearchProducts.apply(null, arguments);
      }
    },
    model: {
      value: _vm.code,
      callback: function callback($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": _vm.mode === _vm.MODE.EDIT || _vm.mode === _vm.MODE.READONLY || !_vm.code
    },
    on: {
      "click": _vm.handleSearchProducts
    }
  }, [_vm._v("確認")])], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.product_ids.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('ProductViewer', {
    attrs: {
      "loading": _vm.isFetchProduct,
      "product": _vm.selectedProduct
    }
  })], 1)])], 1), _c('div', [_c('b-form-group', {
    attrs: {
      "label": "群組類型",
      "label-for": "group_types",
      "label-cols": "6",
      "label-cols-lg": "2"
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "id": "checkbox-group-2",
      "name": "group_types",
      "disabled": _vm.mode === _vm.MODE.EDIT || _vm.mode === _vm.MODE.READONLY,
      "state": _vm.v$.form.group_type_ids.$error ? false : null
    },
    model: {
      value: _vm.form.group_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "group_type_ids", $$v);
      },
      expression: "form.group_type_ids"
    }
  }, _vm._l(_vm.groupTypes, function (groupType) {
    return _c('b-form-checkbox', {
      key: groupType.id,
      attrs: {
        "value": groupType.id
      }
    }, [_c('div', {
      staticClass: "pt-1"
    }, [_vm._v(_vm._s(groupType.name))])]);
  }), 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.group_type_ids.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品可賣量",
      "label-for": "input-1"
    }
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.salableQuantity) + " ")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最高購買數",
      "label-for": "once_max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_max_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "state": _vm.v$.form.once_max_quantity.$error ? false : null,
      "readonly": ""
    },
    model: {
      value: _vm.form.once_max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_max_quantity", $$v);
      },
      expression: "form.once_max_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_max_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於商品總數上限 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最低購買數",
      "label-for": "once_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "disabled": _vm.mode === _vm.MODE.EDIT || _vm.mode === _vm.MODE.READONLY,
      "state": _vm.v$.form.once_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_quantity", $$v);
      },
      expression: "form.once_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於每人最高購買數 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單數量遞增數",
      "label-for": "once_increase_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_increase_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "disabled": _vm.mode === _vm.MODE.EDIT || _vm.mode === _vm.MODE.READONLY,
      "state": _vm.v$.form.once_increase_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_increase_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_increase_quantity", $$v);
      },
      expression: "form.once_increase_quantity"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "開始時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.mode === _vm.MODE.EDIT || _vm.mode === _vm.MODE.READONLY,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "date", $$v);
      },
      expression: "form.start_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "disabled": _vm.mode === _vm.MODE.EDIT || _vm.mode === _vm.MODE.READONLY
    },
    model: {
      value: _vm.form.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "time", $$v);
      },
      expression: "form.start_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.time.HH.$error || !_vm.v$.form.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "截止時間",
      "content-cols": "12",
      "content-cols-lg": "6",
      "description": "*達截止時間系統將自動結團"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": {
        'is-invalid': _vm.v$.form.start_at.$invalid
      },
      "disabledDates": _vm.disabledDates,
      "disabled": _vm.mode === _vm.MODE.READONLY
    },
    model: {
      value: _vm.form.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "date", $$v);
      },
      expression: "form.end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 截止時間必須大於開團時間 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.form.start_at.time.HH.$error || _vm.v$.form.start_at.time.mm.$error || _vm.v$.form.start_at.date.beforeEndAt.$invalid
      }],
      "disabled": _vm.mode === _vm.MODE.READONLY
    },
    model: {
      value: _vm.form.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "time", $$v);
      },
      expression: "form.end_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.time.HH.$error || !_vm.v$.form.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "員工編號",
      "label-for": "tracking_code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 w-100 w-lg-35",
    attrs: {
      "id": "tracking_code",
      "formatter": function formatter(value) {
        return value.length > 6 ? value.slice(0, 6) : value;
      },
      "state": _vm.v$.form.tracking_code.$error ? false : null,
      "readonly": ""
    },
    model: {
      value: _vm.form.tracking_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tracking_code", $$v);
      },
      expression: "form.tracking_code"
    }
  }), _vm.v$.form.tracking_code.required.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 此欄位為必填 ")]) : _vm._e(), _vm.v$.form.tracking_code.lengthSix.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 需為6碼數字 ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "順序",
      "label-for": "order"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 w-100 w-lg-35",
    attrs: {
      "id": "order",
      "type": "number",
      "disabled": _vm.mode === _vm.MODE.EDIT || _vm.mode === _vm.MODE.READONLY,
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      }
    },
    model: {
      value: _vm.form.order,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "order", $$v);
      },
      expression: "form.order"
    }
  }), _vm.v$.form.order.required.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 此欄位為必填 ")]) : _vm._e()], 1)], 1)])], 2)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger",
      "disabled": _vm.isFetchGroupbuying || _vm.isSubmmiting
    },
    on: {
      "click": _vm.handleCancelGroupbuy
    }
  }, [_vm.mode === _vm.MODE.CREATE ? [_vm._v("取消開團")] : _vm._e(), _vm.mode === _vm.MODE.EDIT ? [_vm._v("取消編輯")] : _vm._e(), _vm.mode === _vm.MODE.READONLY ? [_vm._v("返回")] : _vm._e()], 2), _vm.mode === _vm.MODE.CREATE || _vm.mode === _vm.MODE.EDIT ? _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.isFetchGroupbuying || _vm.isSubmmiting
    },
    on: {
      "click": _vm.handleSubmitGroupbuy
    }
  }, [_vm._v(_vm._s(_vm.mode === _vm.MODE.EDIT ? "確認編輯" : "確認開團"))]) : _vm._e()], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }